import {
  fieldValueValidators,
  ContentLengthSchema,
} from '@/app/features/products/common/components/frontend-processing/validators';
import { FileColumns } from '@/app/features/products/common/components/file-selection';
import { InputLabelsMap } from '@ssar-app/domain';

export interface TableColumnWidths {
  columnWidths: number[];
  tableWidthInPixels: number;
}
const calculateTableColumnWidths = (
  fileHeaders: string[],
  data: FileColumns,
  rowSamplingCount = 100,
): TableColumnWidths => {
  // console.log('Calculating Widths');
  const charWidthInPixels = 14;
  const maxAllowedWidthForCol = 400;
  const columnCharPadding = 0;
  const idealMaxHeaderLength = 210;
  const fileHeadersLengthInPixels = fileHeaders.map(
    (a) => a.length * charWidthInPixels,
  );
  const maxFileHeadersLengthInPixels = fileHeadersLengthInPixels.reduce(
    (acc, cur) => (acc < cur ? cur : acc),
    idealMaxHeaderLength,
  );

  const columnWidths = data.map((cols, _colIndex) => {
    const toReturn =
      cols
        .filter((a, index) => index < rowSamplingCount)
        .reduce((acc, curr, _currIndex) => {
          const toReturn = Math.max(
            acc,
            curr?.toString().length * charWidthInPixels || 0,
          );
          return toReturn > maxAllowedWidthForCol
            ? maxAllowedWidthForCol
            : toReturn;
        }, maxFileHeadersLengthInPixels) + columnCharPadding;

    return toReturn;
  });

  // console.log('columnWidths: ', columnWidths);

  const totalTableWidthInPixels = columnWidths.reduce(
    (acc, curr) => acc + curr,
    0,
  );
  const tableWidthInPixels = totalTableWidthInPixels;
  return {
    columnWidths,
    tableWidthInPixels,
  };
};

export { calculateTableColumnWidths };

export interface FileContentValidationResult {
  errors: (string | undefined)[];
  errorsCount: number;
}
const validateFileContent = (
  data: FileColumns,
  fileHeaders: string[],
  inputLabelsMap: InputLabelsMap,
): FileContentValidationResult[] => {
  // console.log(`Valdiating fields of length: ${fileHeaders.length}`);
  const toReturn: FileContentValidationResult[] = [];
  fileHeaders.forEach((entry, index) => {
    const validator =
      fieldValueValidators[entry?.toLowerCase() || ''] ||
      ContentLengthSchema(entry);
    if (!validator) {
      // console.log(`Validator not found for : ${entry}`);
      toReturn.push({
        errors: [],
        errorsCount: 0,
      });
    } else {
      console.log(`Validator found for : ${entry}`, validator);
      const errors = data[index].map((value) => {
        try {
          validator.validateSync(value, {
            context: {
              getInputLabelsMap() {
                return inputLabelsMap;
              },
            },
          });
          return undefined;
        } catch (err) {
          // console.error(err);
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          return (err as any).message;
        }
      });
      toReturn.push({
        errors,
        errorsCount: errors.filter((a) => a).length,
      });
    }
  });
  return toReturn;
};

export { validateFileContent };
